package music.jammers.client.shared.component.card.info.presentation.ui

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.ExposedDropdownMenuDefaults.TrailingIcon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.MenuAnchorType.Companion.PrimaryNotEditable
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import music.jammers.client.shared.component.card.info.di.CardInfoDIComponent
import music.jammers.shared.event.domain.model.CardInfo

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun CardInfoSpinnerComponent(
    placeHolder: String,
    errorText: String?,
    modifier: Modifier,
    onCardInfoChanged: (CardInfo) -> Unit,
) {
    val viewModel = remember { CardInfoDIComponent().viewModel.apply { onReady() } }
    val state = viewModel.state

    val cardInfoList = state.value.items
    val selected = state.value.selected

    var componentErrorText = state.value.error?.message

    if (componentErrorText == null) {
        componentErrorText = errorText
    }

    var expanded by remember { mutableStateOf(false) }

    ExposedDropdownMenuBox(
        expanded = expanded,
        onExpandedChange = { expanded = it },
        modifier = modifier,
    ) {
        TextField(
            modifier = modifier.menuAnchor(PrimaryNotEditable, true),
            value = selected?.name ?: "",
            onValueChange = {},
            readOnly = true,
            singleLine = true,
            placeholder = { Text(placeHolder) },
            trailingIcon = { TrailingIcon(expanded = expanded) },
            colors = TextFieldDefaults.colors(
                focusedContainerColor = Color.Transparent,
                disabledContainerColor = Color.Transparent,
                unfocusedContainerColor = Color.Transparent,
                errorContainerColor = Color.Transparent,
            ),
            supportingText = {
                if (componentErrorText != null) {
                    Text(
                        modifier = Modifier.fillMaxWidth(),
                        text = componentErrorText,
                        color = MaterialTheme.colorScheme.error
                    )
                }
            },
        )

        if (componentErrorText == null) {
            Spacer(modifier = Modifier.size(5.8.dp))
        }

        ExposedDropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
        ) {
            cardInfoList.forEach { option ->
                DropdownMenuItem(
                    text = {
                        Text(option.name, style = MaterialTheme.typography.bodyLarge)
                    },
                    onClick = {
                        viewModel.onSelected(option)
                        expanded = false
                        onCardInfoChanged(option)
                    },
                    contentPadding = ExposedDropdownMenuDefaults.ItemContentPadding,
                )
            }
        }
    }
}